export enum PassengerTypeEnum {
    adult = "ADULT",
    child = "CHILD",
    infant = "INFANT",
    senior = "SENIOR",
    student = "STUDENT",
    prm = "PRM",
    wheelchair = "WHEELCHAIR"
}

// INT and preprod Transcity renamed INFANT to YOUNG_CHILD; prod still sends INFANT.
// Accept both, but keep the API's own value wherever it is sent back (e.g. companions).
const INFANT_TYPE_VALUES = [PassengerTypeEnum.infant, "YOUNG_CHILD"];

export const isInfantType = (value?: string): boolean =>
    INFANT_TYPE_VALUES.includes(value?.toUpperCase() ?? "");

// Companions saved before the rename keep INFANT; match them to whichever infant value the API sends.
export const isSamePassengerType = (a?: string, b?: string): boolean =>
    !!a && (a.toUpperCase() === b?.toUpperCase() || (isInfantType(a) && isInfantType(b)));
